import { isNullOrUndefined } from 'util';
import {
    AbstractControl,
    FormArray,
    FormControl,
    FormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';

export class NsValidators {
    public static vinValidator(control: FormControl) {
        let valid = true;
        let errorMessage = '';
        const vin = control.value;

        if (isNullOrUndefined(vin)) {
            valid = false;
        } else {
            const length = vin.length;
            const reg = /[ioq]/i;
            if (reg.test(vin)) {
                valid = false;
                errorMessage +=
                    ' Numer VIN zawiera niedozwolne znaki (i, o, q).';
            }
            if (length !== 17) {
                valid = false;
                errorMessage += ' Numer VIN zawiera niewłaściwą liczbę znaków.';
            }
        }
        return valid ? null : { errorMessage: errorMessage };
    }

    public static peselValidator(control: AbstractControl) {
        let valid = true;
        const value = control.value;
        let errorMessage = '';
        if (value && !isNullOrUndefined(value)) {
            const reg = /^[0-9]{11}$/;
            if (reg.test(value) == false) {
                valid = false;
                errorMessage = 'Podany pesel jest nieprawidłowy.';
            } else {
                const dig = ('' + value).split('');
                let controlNr =
                    (1 * parseInt(dig[0]) +
                        3 * parseInt(dig[1]) +
                        7 * parseInt(dig[2]) +
                        9 * parseInt(dig[3]) +
                        1 * parseInt(dig[4]) +
                        3 * parseInt(dig[5]) +
                        7 * parseInt(dig[6]) +
                        9 * parseInt(dig[7]) +
                        1 * parseInt(dig[8]) +
                        3 * parseInt(dig[9])) %
                    10;
                if (controlNr == 0) {
                    controlNr = 10;
                }
                controlNr = 10 - controlNr;
                if (parseInt(dig[10]) == controlNr) {
                    valid = true;
                } else {
                    valid = false;
                    errorMessage = 'Podany pesel jest nieprawidłowy.';
                }
            }
        } else {
            valid = true;
        }

        return valid ? null : { errorMessage: errorMessage };
    }

    public static registrationNumberValidator(control: AbstractControl) {
        let valid = true;
        const value = control.value;
        let errorMessage = '';
        if (isNullOrUndefined(value)) {
            valid = false;
        } else {
            if (value.length < 7 || value.length > 8) {
                valid = false;
                errorMessage =
                    'Podany numer zawiera niewłaściwą liczbę znaków.';
            }
        }
        return valid ? null : { errorMessage: errorMessage };
    }

    public static notEarlierThanToday(control: AbstractControl) {
        let valid = true;
        let errorMessage = '';
        const value: string = control.value;
        if (!isNullOrUndefined(value)) {
            const today = new Date();
            const date = new Date(value);

            today.setHours(0);
            today.setMilliseconds(0);
            today.setMinutes(0);
            today.setSeconds(0);

            if (date < today) {
                valid = false;
                errorMessage =
                    'Data nie może być wcześniejsza niż data dzisiejsza.';
            }
        }

        return valid ? null : { errorMessage: errorMessage };
    }

    public static regonValidator(control: AbstractControl) {
        let valid = true;
        let errorMessage: string = '';

        let value = control.value;

        if (!isNullOrUndefined(value)) {
            let n = value.length;
            let w;
            let cd = 0; // Control digit (last digit)
            let isOnlyDigit = /^\d+$/.test(value);

            if (n !== 9 && n !== 14 && !isOnlyDigit) {
                valid = false;
                errorMessage = 'Podany regon jest nieprawidłowy.';
            }

            if (n === 9) {
                w = [8, 9, 2, 3, 4, 5, 6, 7];
            } else {
                w = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
            }

            for (let i = 0; i < n - 1; i++) {
                cd += w[i] * parseInt(value.charAt(i));
            }

            cd %= 11;

            if (cd === 10) {
                cd = 0;
            }

            if (cd !== parseInt(value.charAt(n - 1))) {
                valid = false;
                errorMessage = 'Podany regon jest nieprawidłowy.';
            } else {
                valid = true;
            }
        }

        return valid ? null : { errorMessage: errorMessage };
    }

    public static nipValidator(control: AbstractControl) {
        let valid = true;
        let errorMessage = '';

        const value = control.value;
        if (!isNullOrUndefined(value)) {
            const nipWithoutDash = value.replace(/-/g, '');
            const reg = /^[0-9]{10}$/;
            if (reg.test(nipWithoutDash) == false) {
                valid = false;
                errorMessage = 'Podany NIP jest nieprawidłowy.';
            } else {
                let dig = ('' + nipWithoutDash).split('');
                let controlNr =
                    (6 * parseInt(dig[0]) +
                        5 * parseInt(dig[1]) +
                        7 * parseInt(dig[2]) +
                        2 * parseInt(dig[3]) +
                        3 * parseInt(dig[4]) +
                        4 * parseInt(dig[5]) +
                        5 * parseInt(dig[6]) +
                        6 * parseInt(dig[7]) +
                        7 * parseInt(dig[8])) %
                    11;
                if (parseInt(dig[9]) == controlNr) {
                    valid = true;
                } else {
                    valid = false;
                    errorMessage = 'Podany NIP jest nieprawidłowy.';
                }
            }
        } else {
            valid = true;
        }

        return valid ? null : { errorMessage: errorMessage };
    }

    public static phoneValidator(control: AbstractControl) {
        let parent = Validators.pattern('^(\\+[0-9 ]{1,4})?([0-9 ]){9,11}$');
        let errorMessage = 'Podany numer telefonu jest niepoprawny';

        let valid = !parent(control);

        return valid ? null : { phoneError: errorMessage };
    }

    public static simplePhoneValidator(control: AbstractControl) {
        let parent = Validators.pattern('^([\\+\\-\\(\\)0-9 ]+)$');
        let errorMessage = 'Podany numer telefonu jest niepoprawny';

        let valid = !parent(control);

        return valid ? null : { phoneError: errorMessage };
    }

    public static krsValidator(control: AbstractControl) {
        let parent = Validators.pattern('^[0-9]{10}$');

        let valid = !parent(control);

        return valid ? null : { krsError: true };
    }

    public static minSelectedCheckboxes(min: number) {
        const validator: ValidatorFn = (
            control: FormArray
        ): { [key: string]: any } => {
            const selectedControls = control.controls
                .map((itemControl) => itemControl.value)
                .filter((isChecked) => !!isChecked);

            return selectedControls.length >= min
                ? null
                : { minSelectedCheckboxes: { valid: false } };
        };

        return validator;
    }
}
